(function () {
  const U = window.UIX;
  const APP = window.APP;
  const el = U.el;
  const esc = U.esc;
  const menuCfg = U.menuCfg;
  const saveMenuCfg = U.saveMenuCfg;

  function dialog() {
    const dlg = document.getElementById("piledlg");
    dlg.innerHTML = "";
    dlg.onclick = null;
    return dlg;
  }

  function copyText(text, button) {
    const done = function (okay) {
      const was = button.textContent;
      button.textContent = okay ? "Copied" : "Copy failed";
      setTimeout(function () { button.textContent = was; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(fallbackCopy(text)); });
    } else {
      done(fallbackCopy(text));
    }
  }

  function fallbackCopy(text) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    let okay = false;
    try { okay = document.execCommand("copy"); } catch (e) { okay = false; }
    document.body.removeChild(ta);
    return okay;
  }

  function cardName(id) {
    const c = id ? RB.Setup.findCard(id) : null;
    return c ? RB.DeckImport.displayName(c) : null;
  }

  function stat(label, value, tone) {
    const s = el("div", "bbiostat" + (tone ? " " + tone : ""));
    s.appendChild(el("span", "mslbl", esc(label)));
    s.appendChild(el("span", "bbiostatv", esc(String(value))));
    return s;
  }

  function preview(parsed, built) {
    const box = el("div", "bbiopreview");
    const row = el("div", "bbiostats");
    const runeTotal = Object.keys(parsed.runes).reduce(function (n, d) { return n + parsed.runes[d]; }, 0);
    row.appendChild(stat("Legend", cardName(parsed.legend) || "none", parsed.legend ? "" : "bad"));
    row.appendChild(stat("Champion", cardName(parsed.champion) || "none", parsed.champion ? "" : "bad"));
    row.appendChild(stat("Battlefields", parsed.battlefields.length + "/3", parsed.battlefields.length === 3 ? "" : "bad"));
    row.appendChild(stat("Runes", runeTotal + "/12", runeTotal === 12 ? "" : "bad"));
    row.appendChild(stat("Main", parsed.deck.length + "/40", parsed.deck.length === 40 ? "" : "bad"));
    if (parsed.side.length) row.appendChild(stat("Side", parsed.side.length));
    if (parsed.codeVersion) row.appendChild(stat("Deck code", "v" + parsed.codeVersion));
    box.appendChild(row);
    const runeLine = Object.keys(parsed.runes).map(function (d) { return parsed.runes[d] + " " + d; }).join(" · ");
    if (runeLine) box.appendChild(el("div", "note", esc(runeLine)));
    if (parsed.unknown.length) {
      const u = el("div", "bbiolist bad");
      u.appendChild(el("div", "mslbl", "Not recognised"));
      for (const line of parsed.unknown) u.appendChild(el("div", "bbioline", esc(line)));
      box.appendChild(u);
    }
    const notes = built ? built.problems.filter(function (p) { return p.indexOf("unknown: ") !== 0; }) : parsed.warnings;
    if (notes.length) {
      const w = el("div", "bbiolist warn");
      w.appendChild(el("div", "mslbl", built && built.valid ? "Notes" : "Problems"));
      for (const line of notes) w.appendChild(el("div", "bbioline", esc(line)));
      box.appendChild(w);
    }
    if (built && built.valid) box.appendChild(el("div", "note good", "Tournament legal — ready to save."));
    return box;
  }

  function importDialog() {
    const dlg = dialog();
    dlg.className = "bbio";
    dlg.appendChild(el("h3", null, "Import deck"));
    dlg.appendChild(el("div", "note", "Paste a text list (\"3 OGN-186\", \"3 Traveling Merchant\", headers like LEGEND / RUNE / SIDEBOARD are fine) or a Piltover Archive deck code."));
    const name = document.createElement("input");
    name.type = "text";
    name.className = "bbioname";
    name.placeholder = "Deck name (defaults to the legend)";
    name.setAttribute("aria-label", "Deck name");
    dlg.appendChild(name);
    const ta = document.createElement("textarea");
    ta.placeholder = "3 OGN-186\n1 OGN-192\n…\n\nor\n\nCMAAAAAAAAAACAQAAAD2MAIA…";
    ta.spellcheck = false;
    dlg.appendChild(ta);
    const prev = el("div", "bbioprevwrap");
    dlg.appendChild(prev);
    const row = el("div", "actions");
    const save = el("button", "btn primary", "Save as build");
    const open = el("button", "btn", "Open in builder");
    const cancel = el("button", "btn ghost", "Cancel");
    row.appendChild(save);
    row.appendChild(open);
    row.appendChild(cancel);
    dlg.appendChild(row);

    let built = null;
    const refresh = function () {
      prev.innerHTML = "";
      const text = ta.value;
      if (!text.trim()) {
        built = null;
        save.disabled = true;
        open.disabled = true;
        prev.appendChild(el("div", "note", "Nothing pasted yet."));
        return;
      }
      const parsed = RB.DeckImport.parseText(text);
      built = RB.DeckImport.toDeck(parsed, { name: name.value.trim() || undefined });
      prev.appendChild(preview(parsed, built));
      save.disabled = !built.deck.legend;
      save.title = built.deck.legend ? (built.valid ? "Store this build under its legend" : "Store it anyway and fix it in the builder later") : "The list needs a legend before it can be filed";
      open.disabled = false;
    };
    ta.oninput = refresh;
    name.oninput = refresh;
    refresh();

    const commit = function (deck) {
      RB.Decklists.saveCustom(deck);
      const cfg = menuCfg();
      cfg.seats[0].deck = deck.id;
      saveMenuCfg(cfg);
      if (APP.deckui) {
        const legend = deck.legend ? RB.Setup.findCard(deck.legend) : null;
        if (legend) APP.deckui.legend = legend.name;
        APP.deckui.showAll = false;
        APP.deckui.search = "";
      }
    };
    save.onclick = function () {
      if (!built || !built.deck.legend) return;
      commit(built.deck);
      dlg.close();
      U.render();
    };
    open.onclick = function () {
      if (!built) return;
      dlg.close();
      U.editDeck(built.deck);
    };
    cancel.onclick = function () { dlg.close(); };
    dlg.onclick = function (ev) { if (ev.target === dlg) dlg.close(); };
    dlg.showModal();
    ta.focus();
  }

  function exportDialog(deck) {
    const dlg = dialog();
    dlg.className = "bbio";
    dlg.appendChild(el("h3", null, "Export " + esc(deck.name || "deck")));
    let code = "";
    let codeErr = null;
    try { code = RB.DeckImport.encodeCode(deck); } catch (e) { codeErr = e.message; }
    const text = RB.DeckImport.exportText(deck);

    const codeHead = el("div", "bbhead");
    codeHead.appendChild(el("span", "mslbl", "Deck code (Piltover Archive)"));
    const copyCode = el("button", "btn small", "Copy code");
    copyCode.disabled = !code;
    copyCode.onclick = function () { copyText(code, copyCode); };
    codeHead.appendChild(copyCode);
    dlg.appendChild(codeHead);
    dlg.appendChild(el("div", "bbiocode selectable", esc(code || ("Cannot encode: " + codeErr))));

    const textHead = el("div", "bbhead");
    textHead.appendChild(el("span", "mslbl", "Text list"));
    const copyList = el("button", "btn small", "Copy list");
    copyList.onclick = function () { copyText(text, copyList); };
    textHead.appendChild(copyList);
    dlg.appendChild(textHead);
    const ta = document.createElement("textarea");
    ta.readOnly = true;
    ta.value = text;
    ta.onfocus = function () { ta.select(); };
    dlg.appendChild(ta);

    const row = el("div", "actions");
    const close = el("button", "btn", "Close");
    close.onclick = function () { dlg.close(); };
    row.appendChild(close);
    dlg.appendChild(row);
    dlg.onclick = function (ev) { if (ev.target === dlg) dlg.close(); };
    dlg.showModal();
  }

  function collectionDialog() {
    const dlg = dialog();
    dlg.className = "bbio";
    dlg.appendChild(el("h3", null, "Deck collection"));
    dlg.appendChild(el("div", "note", "Your decks live in this browser only. Download them as one file here and import that file on another device or site to carry them over."));

    const exportHead = el("div", "bbhead");
    const decks = RB.Decklists.exportCollection();
    exportHead.appendChild(el("span", "mslbl", esc(decks.length + " deck" + (decks.length === 1 ? "" : "s") + " to export")));
    const dl = el("button", "btn small", "Download JSON");
    dl.disabled = !decks.length;
    dl.onclick = function () {
      const blob = new Blob([JSON.stringify(decks, null, 1)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "riftbound-decks-" + new Date().toISOString().slice(0, 10) + ".json";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
    };
    exportHead.appendChild(dl);
    dlg.appendChild(exportHead);

    const importHead = el("div", "bbhead");
    importHead.appendChild(el("span", "mslbl", "Import a collection file"));
    const pick = el("button", "btn small", "Choose file");
    importHead.appendChild(pick);
    dlg.appendChild(importHead);
    const file = document.createElement("input");
    file.type = "file";
    file.accept = ".json,application/json";
    file.hidden = true;
    dlg.appendChild(file);
    const prev = el("div", "bbioprevwrap");
    prev.appendChild(el("div", "note", "A file from Download JSON, a single deck JSON, or a list file from data/meta/lists."));
    dlg.appendChild(prev);

    let staged = null;
    pick.onclick = function () { file.click(); };
    file.onchange = function () {
      const f = file.files && file.files[0];
      if (!f) return;
      f.text().then(function (text) {
        prev.innerHTML = "";
        let parsed = null;
        try { parsed = JSON.parse(text); } catch (e) { parsed = null; }
        const list = Array.isArray(parsed) ? parsed : (parsed && typeof parsed === "object" ? [parsed] : null);
        if (!list) {
          staged = null;
          apply.disabled = true;
          prev.appendChild(el("div", "note bad", "That file is not JSON."));
          return;
        }
        staged = list;
        const ok = list.filter(function (d) { return d && Array.isArray(d.deck); });
        const existing = {};
        for (const d of RB.Decklists.custom()) existing[d.id] = true;
        const dup = ok.filter(function (d) { return d.id && existing[d.id]; }).length;
        const box = el("div", "bbiostats");
        box.appendChild(stat("Decks", ok.length, ok.length ? "" : "bad"));
        if (dup) box.appendChild(stat("Overwrite", dup, "warn"));
        if (ok.length !== list.length) box.appendChild(stat("Not decks", list.length - ok.length, "bad"));
        prev.appendChild(box);
        const names = el("div", "bbiolist");
        for (const d of ok.slice(0, 12)) names.appendChild(el("div", "bbioline", esc(d.name || d.id || "unnamed")));
        if (ok.length > 12) names.appendChild(el("div", "bbioline", esc("… and " + (ok.length - 12) + " more")));
        prev.appendChild(names);
        apply.disabled = !ok.length;
      });
    };

    const row = el("div", "actions");
    const apply = el("button", "btn primary", "Import");
    apply.disabled = true;
    apply.onclick = function () {
      if (!staged) return;
      const res = RB.Decklists.importCollection(staged);
      dlg.close();
      APP.error = res.skipped.length ? res.skipped.length + " entries skipped" : null;
      U.render();
    };
    const close = el("button", "btn ghost", "Close");
    close.onclick = function () { dlg.close(); };
    row.appendChild(apply);
    row.appendChild(close);
    dlg.appendChild(row);
    dlg.onclick = function (ev) { if (ev.target === dlg) dlg.close(); };
    dlg.showModal();
  }

  Object.assign(U, { importDeckDialog: importDialog, exportDeckDialog: exportDialog, collectionDialog: collectionDialog });
})();
